import React, { useEffect } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { PrivateRoute, PublicRouteLogin } from './Auth/Auth';
import HomePage from './pages/Public/Home/Index';
import Login from './pages/Public/Login/Index';
import Menu from './pages/Private/Menu/Index';

const listRoutesPublic = ['', '/', '/home', '/login'];
const listRoutesPrivate = ['/private'];

function RouteGuard() {
  const history = useHistory();

  useEffect(() => {
    const pathname = history?.location?.pathname || '';
    const replaceHistory =
      pathname.substr(-1, 1) === '/'
        ? pathname.replace(/.$/, '')
        : pathname;

    const list = [...listRoutesPublic, ...listRoutesPrivate];

    if (!list.some((l) => l === replaceHistory)) {
      toast.warning('Página não encontrada');
      setTimeout(() => {
        window.location.href = '/home';
      }, 1000);
    }
  }, [history, history?.location?.pathname]);

  return null;
}

export default function AppRoutes() {
  return (
    <>
      <RouteGuard />
      <Switch>
        <Route exact path="/" render={() => <HomePage />} />
        <Route exact path="/home" render={() => <HomePage />} />
        <PublicRouteLogin exact path="/login" component={Login} />
        <PrivateRoute exact path="/private" component={Menu} />
      </Switch>
    </>
  );
}
